const BottomDiv = ({ width, height }) => {
    return (
        <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 749 184" width={width} height={height} className="md:h-[135px]">
            <defs>
                <clipPath clipPathUnits="userSpaceOnUse" id="cp1">
                    <path d="m0 0h749v183.75h-749z" />
                </clipPath>
            </defs>
            <g id="Clip-Path" clipPath="url(#cp1)">
                <g>
                    <path fillRule="evenodd" fill="#ffffff" d="m747.1 183.7h-749.2v-113.8h-1.4v-69.9h229.2c22.3 0 40.7 16.5 43.6 38 12.6 47.1 55.2 79.8 104.2 79.8 49.3 0 92-33 104.4-80.4 3.1-21.2 21.4-37.4 43.4-37.4h227.3v69.9h-1.5z" />
                </g>
            </g>
        </svg>
    );
};

export default BottomDiv;
